<div class="text-center mx-7 top-margin">
  <h1>{{ 'SERVICE_PAGES.NOT_FOUND.TITLE' | translate }}</h1>
  <h2>{{ 'SERVICE_PAGES.NOT_FOUND.MESSAGE' | translate }}</h2>
  <button routerLink="/">{{ 'SERVICE_PAGES.NOT_FOUND.BUTTON' | translate }}</button>
</div>
